import styled from "styled-components";

export const Container = styled.section`
  padding-top: 4rem;
  padding-bottom: 4rem;
  @media (max-width: 575.98px) {
    padding-top: 7rem;
  }
  p {
    text-align: left;
  }
`;

export const ComodidadeContainer = styled.div`
  margin-top: 4rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  justify-content: center;
  align-items: center;
  gap: 4rem;
`;
